var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stop_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6717_6873",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6717_6873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stop_circle_2",
    d: "M14 28H28V14H14V28ZM21 38.5C18.5792 38.5 16.3042 38.0406 14.175 37.1219C12.0458 36.2031 10.1937 34.9563 8.61875 33.3813C7.04375 31.8063 5.79688 29.9542 4.87813 27.825C3.95937 25.6958 3.5 23.4208 3.5 21C3.5 18.5792 3.95937 16.3042 4.87813 14.175C5.79688 12.0458 7.04375 10.1937 8.61875 8.61875C10.1937 7.04375 12.0458 5.79688 14.175 4.87813C16.3042 3.95937 18.5792 3.5 21 3.5C23.4208 3.5 25.6958 3.95937 27.825 4.87813C29.9542 5.79688 31.8063 7.04375 33.3813 8.61875C34.9563 10.1937 36.2031 12.0458 37.1219 14.175C38.0406 16.3042 38.5 18.5792 38.5 21C38.5 23.4208 38.0406 25.6958 37.1219 27.825C36.2031 29.9542 34.9563 31.8063 33.3813 33.3813C31.8063 34.9563 29.9542 36.2031 27.825 37.1219C25.6958 38.0406 23.4208 38.5 21 38.5Z",
    fill: "#D32F2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.7f78dfcff0d1361f9073cc3afa424b13.svg";
export { ForwardRef as ReactComponent };